import { render, staticRenderFns } from "./integrationTable.vue?vue&type=template&id=4b25df30&scoped=true"
import script from "./integrationTable.vue?vue&type=script&lang=js"
export * from "./integrationTable.vue?vue&type=script&lang=js"
import style0 from "./integrationTable.vue?vue&type=style&index=0&id=4b25df30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b25df30",
  null
  
)

export default component.exports